var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35929_46269)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.494141,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#D5D5D5",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0772 30.5L12.8208 30.5C11.2631 30.5 10.0003 29.2372 10.0003 27.6795L10.0003 17.4231C10.0003 15.8654 11.2631 14.6026 12.8208 14.6026L14.1026 14.6026L14.1026 13.174C14.1026 11.6972 15.2998 10.5 16.7766 10.5L26.1538 10.5C28.278 10.5 30 12.222 30 14.3462L30 23.7235C30 25.2003 28.8028 26.3975 27.326 26.3975L25.8977 26.3975L25.8977 27.6795C25.8977 29.2372 24.6349 30.5 23.0772 30.5ZM25.8977 24.859L27.326 24.859C27.9531 24.859 28.4615 24.3506 28.4615 23.7235L28.4615 14.3462C28.4615 13.0717 27.4283 12.0385 26.1538 12.0385L16.7766 12.0385C16.1494 12.0385 15.641 12.5469 15.641 13.174L15.641 14.6026L23.0772 14.6026C24.6349 14.6026 25.8977 15.8654 25.8977 17.4231L25.8977 24.859ZM23.077 28.9614C23.785 28.9614 24.359 28.3874 24.359 27.6794L24.359 17.423C24.359 16.7149 23.785 16.1409 23.077 16.1409L12.8205 16.1409C12.1125 16.1409 11.5385 16.7149 11.5385 17.423L11.5385 27.6794C11.5385 28.3874 12.1125 28.9614 12.8206 28.9614L23.077 28.9614Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35929_46269"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCount);
export default __webpack_public_path__ + "static/media/copy-count.1e619945dd4c005122887a766a497907.svg";
export { ForwardRef as ReactComponent };